import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// 旧ドメインからのリダイレクト
if (
  window.location.hostname === 'liavoice-3408f.web.app' ||
  window.location.hostname === 'liavoice-3408f.firebaseapp.com'
) {
  window.location.replace(
    'https://liavoice.com' + window.location.pathname + window.location.search + window.location.hash
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
